import { createReducer } from '@reduxjs/toolkit';
import {
    removeProduct,
    setProductCollection,
    setProductRecords,
    setProductsCollectionLoading,
} from './actions';
import type { ProductDataModel } from './types';

const DEFAULT_COLLECTION_STATE = {
    identifiers: [],
    isLoading: false,
    isInitialized: false,
    reload: false,
};

type ProductRecords = Record<string, ProductDataModel>;

interface ProductsState {
    records: ProductRecords;
    details: Record<string, { isLoading: boolean }>;
    collections: Record<
        string,
        {
            identifiers: string[];
            isLoading: boolean;
            isInitialized: boolean;
            next?: string;
        }
    >;
}

export const productsReducer = createReducer<ProductsState>(
    {
        records: {},
        details: {},
        collections: {},
    },
    (builder) => {
        builder
            .addCase(setProductRecords, (draft, action) => {
                action.payload.forEach((productModel) => {
                    draft.records[productModel.id] = productModel;
                });
            })

            .addCase(setProductCollection, (draft, action) => {
                const { namespace, next, identifiers } = action.payload;

                draft.collections[namespace] = draft.collections[namespace] ?? {
                    ...DEFAULT_COLLECTION_STATE,
                };

                draft.collections[namespace].next = next;
                draft.collections[namespace].identifiers = [
                    ...draft.collections[namespace].identifiers,
                    ...identifiers,
                ];
            })
            .addCase(setProductsCollectionLoading, (draft, action) => {
                const { namespace, isLoading } = action.payload;

                draft.collections[namespace] = draft.collections[namespace] ?? {
                    ...DEFAULT_COLLECTION_STATE,
                };
                draft.collections[namespace].isLoading = isLoading;

                if (!isLoading && draft.collections[namespace].identifiers.length >= 0) {
                    draft.collections[namespace].isInitialized = true;
                }
            })
            .addCase(removeProduct, (draft, action) => {
                const { namespace, productId } = action.payload;
                const identifiers = draft.collections[namespace].identifiers;

                draft.collections[namespace].identifiers = identifiers.filter(
                    (id) => id !== productId,
                );
            });
    },
);
